import React from 'react';
import {connect} from "react-redux";
import {List, ListItem} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import Dialog from 'material-ui/Dialog';
import FormationForm from '../../entreprise/bodies/entretiens/passer_entretien/comps/FormationForm';
import RaisedButton from 'material-ui/RaisedButton';
import Divider from 'material-ui/Divider';
import TitleMedium from '../../shared/utils/TitleMedium';
import AuthService from "../../../services/AuthService";
import {getInfosSalarie} from "../../../actions/salarie/actions_salarie_1";
import moment from "../../shared/utils/moment_fr";
import CustomPaper from "../../shared/utils/CustomPaper";
import Alert from "../../shared/utils/Alert";
import StarRatingComponent from 'react-star-rating-component';
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";


class FormationsSalarie extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            projet: null,
            isModal1Open: false,
            isModal2Open: false,
            isEvaluationOpen: false,
            selectedFormation: null,
            formation_souhaitee: {}
        };
        this.Auth = new AuthService();
        this.saveProjetPro = this.saveProjetPro.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.evaluateFormation = this.evaluateFormation.bind(this);
        this.handleSubmitFormationSouhaitee = this.handleSubmitFormationSouhaitee.bind(this);
        this.hamdleDeleteFormationSouhaitee = this.hamdleDeleteFormationSouhaitee.bind(this);
    }

    onSuccess() {
        this.setState({modalOpen: false});
        this.props.dispatch(getInfosSalarie());
    }


    saveProjetPro() {
        this.Auth.fetch('/salarie/projet_pro_exprime', {
            method: 'POST',
            data: this.state
        }).then(x => {
            this.props.dispatch(getInfosSalarie());
            alert('Enregistrement avec succès.');
        });
    }

    evaluateFormation() {
        this.Auth.fetch('/salarie/formation/evaluate', {
            method: 'POST',
            data: this.state.selectedFormation
        }).then(x => {
            this.props.dispatch(getInfosSalarie());
            this.setState({isEvaluationOpen: false});
            alert('Enregistrement avec succès.');
        }).catch(x => window.alert('Une erreur est survenue.'));

    }

    handleSubmitFormationSouhaitee() {
        this.Auth.fetch('/salarie/formation_souhaitee', {
            method: 'POST',
            data: this.state.formation_souhaitee
        }).then(x => {
            this.props.dispatch(getInfosSalarie());
            this.setState({isModal2Open: false});
            alert('Enregistrement avec succès.');
        }).catch(x => window.alert('Une erreur est survenue.'));
    }

    hamdleDeleteFormationSouhaitee(f) {
        this.Auth.fetch('/salarie/formation_souhaitee/' + f.id, {
            method: 'DELETE'
        }).then(x => {
            this.props.dispatch(getInfosSalarie());
            alert('Enregistrement avec succès.');
        }).catch(x => window.alert('Une erreur est survenue.'));
    }


    render() {
        return (
            <CustomPaper title="Formations">
                <div style={{padding: 20}} className={'row'}>
                    <div className={'col'}>
                        <TitleMedium title='Formations Effectuées'/>
                        <List>
                            {this.props.formations && this.props.formations.map(f => {
                                    return <ListItem
                                        key={f.id}
                                        primaryText={f.nom_formation + (f.nom_organisme_de_formation ? ` ( ${f.nom_organisme_de_formation}  )` : '')}
                                        secondaryTextLines={2}
                                        secondaryText={
                                            <p>{f.type_validation}<br/>{f.initiateur + ' -- ' + moment(f.date_rea).format('ll')}
                                            </p>
                                        }
                                        rightAvatar={<Avatar style={{fontSize: 12}}>{f.duree} h</Avatar>}
                                    >
                                        <StarRatingComponent
                                            name='rating'
                                            value={Number(f.rating)}
                                        />
                                    </ListItem>
                                }
                            )}
                        </List>
                        <RaisedButton
                            label="Ajouter une formation effectuée"
                            style={{marginTop: 15}}
                            onClick={() => this.setState({isModal1Open: true})}
                            primary={true}
                        />
                        <RaisedButton
                            label="Evaluer une session de formation"
                            style={{marginLeft: 15}}
                            onClick={() => this.setState({isEvaluationOpen: true})}
                            secondary={true}
                        />
                        {
                            this.state.isEvaluationOpen &&
                            <div style={{marginTop: 15}}>
                                <Alert text="Veuillez évaluer une session de formation parmi celles dans la liste"/>
                                <SelectField
                                    value={this.state.selectedFormation ? this.state.selectedFormation.id : '0'}
                                    fullWidth={false}
                                    floatingLabelText="Formations"
                                    onChange={(x, y, z) => this.setState({selectedFormation: this.props.formations.filter(f => f.id === z)[0]})}
                                    maxHeight={400}
                                >
                                    {
                                        this.props.formations.map(f =>
                                            <MenuItem
                                                key={f.id}
                                                value={f.id}
                                                primaryText={f.nom_formation}
                                            />
                                        )
                                    }
                                </SelectField><br/>
                                {
                                    this.state.selectedFormation &&
                                    <div>
                                        <label>Satisfaction globale : </label><br/>
                                        <StarRatingComponent
                                            name='rating-edit'
                                            value={Number(this.state.selectedFormation ? this.state.selectedFormation.rating : 3)}
                                            onStarClick={(nextValue) => this.setState(
                                                {
                                                    selectedFormation: {
                                                        ...this
                                                            .state.selectedFormation,
                                                        rating: nextValue
                                                    }
                                                }
                                            )}
                                        /><br/>
                                        <label>Commentaire sur la session de formation : </label><br/>
                                        <textarea
                                            style={{width: '100%'}}
                                            value={this.state.selectedFormation.rating_comment || ''}
                                            onChange={x => this.setState(
                                                {
                                                    selectedFormation: {
                                                        ...this
                                                            .state.selectedFormation,
                                                        rating_comment: x.target.value
                                                    }
                                                }
                                            )}
                                        /><br/>
                                        <RaisedButton
                                            label="Confirmer l'évaluation"
                                            style={{marginTop: 15}}
                                            onClick={this.evaluateFormation}
                                            primary={true}
                                        />
                                        <RaisedButton
                                            label="Annuler"
                                            style={{marginLeft: 15}}
                                            onClick={() => this.setState({isEvaluationOpen: false})}
                                            primary={false}
                                        />
                                    </div>
                                }

                            </div>
                        }
                        <br/><br/>
                        <Dialog
                            title="Ajout de formation"
                            modal={false}
                            open={this.state.isModal1Open}
                            onRequestClose={() => this.setState({isModal1Open: false})}
                            autoScrollBodyContent={true}
                        >
                            <FormationForm id_salarie={this.props.id_salarie} onSuccess={this.onSuccess}/>
                        </Dialog>
                        <TitleMedium title='Formations Souhaitée'/>
                        <Divider style={{marginBottom: 25}}/>
                        <Alert text="Veuillez ajouter ci-dessous les formations qui vous intéressent "/>
                        {
                            this.props.formations_souhaitees &&

                            <table className="table">
                                <thead>
                                <tr>
                                    <th>Nom de la formation</th>
                                    <th>Nom de l'organisme de la formation</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.props.formations_souhaitees.map(
                                        f =>
                                            <tr key={f.id}>
                                                <td>{f.nom_formation_souhaitee}</td>
                                                <td>{f.nom_organisme_de_formation_souhaitee}</td>
                                                <td
                                                    onClick={() => this.hamdleDeleteFormationSouhaitee(f)}
                                                    style={{cursor: 'pointer', color: 'red'}}>Supprimer
                                                </td>
                                            </tr>
                                    )
                                }

                                </tbody>
                            </table>


                        }
                        <Dialog
                            title="Ajout de formation souhaitée"
                            modal={false}
                            open={this.state.isModal2Open}
                            onRequestClose={() => this.setState({isModal2Open: false})}
                            autoScrollBodyContent={true}
                        >
                            <ValidatorForm
                                ref="form"
                                onSubmit={this.handleSubmitFormationSouhaitee}
                            >
                                <TextValidator
                                    value={this.state.formation_souhaitee.nom_formation_souhaitee}
                                    onChange={(x, y) => this.setState({
                                        formation_souhaitee: {
                                            ...this.state.formation_souhaitee,
                                            nom_formation_souhaitee: y
                                        }
                                    })}
                                    fullWidth={true}
                                    name='nom_formation_souhaitee'
                                    type="text"
                                    validators={['required', 'trim']}
                                    errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                                    floatingLabelText="Nom de la formation"
                                />
                                <TextValidator
                                    value={this.state.formation_souhaitee.nom_organisme_de_formation_souhaitee}
                                    onChange={(x, y) => this.setState({
                                        formation_souhaitee: {
                                            ...this.state.formation_souhaitee,
                                            nom_organisme_de_formation_souhaitee: y
                                        }
                                    })}
                                    fullWidth={true}
                                    name='nom_organisme_de_formation_souhaitee'
                                    type="text"
                                    floatingLabelText="Nom de l'organisme de la formation"
                                />
                                <RaisedButton
                                    label="Ajouter"
                                    style={{marginTop: 15}}
                                    type='submit'
                                    primary={true}
                                />
                            </ValidatorForm>
                        </Dialog>
                        <RaisedButton
                            label="Ajouter une formation souhaitée"
                            style={{marginTop: 15}}
                            onClick={() => this.setState({isModal2Open: true})}
                            primary={true}
                        />
                    </div>
                </div>
            </CustomPaper>

        );
    }
}

function mapStateToProps(store) {
    return {
        formations: store.salarie.infos.formations,
        formations_souhaitees: store.salarie.infos.formations_souhaitees,
        id_salarie: store.salarie.infos.id
    }
}

export default connect(mapStateToProps)(FormationsSalarie);


// WEBPACK FOOTER //
// ./src/components/salarie/bodies/FormationsSalarie.js